import React from "react";
import { connect } from "react-redux";
import {
  containsString,
  formatDate,
  formatNumber,
  formatWithSpaces,
} from "../../../shared/utility";
import { MESSAGES } from "../../../constants";

const OrderSummaryCard = (props) => {
  const { order, currencyCode } = props;

  return (
    <div className="card-container order-summary-container">
      <div className="card mb-4">
        <div className="card-body">
          <div className="row">
            <div className="col-md-3">
              <div className="orderSummary-primaryDetails">
                <p className="price">
                  {currencyCode}
                  {formatNumber(order.total_inc_tax)}
                </p>
                <div class="orderSummary-status lozenge lozenge--info">
                  {order.status}
                </div>
                <div className="d-flex">
                  <span className="text-content me-5 fw-bold">Order date</span>
                  <span className="text-content">
                    {formatDate(order.date_created)}
                  </span>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="second-section">
                <div className="d-flex justify-content-between">
                  <p className="text-content fw-bold">Shipping</p>
                  <p className="text-content">
                    {currencyCode}
                    {formatNumber(order.base_shipping_cost)}
                  </p>
                </div>
                <div className="d-flex justify-content-between">
                  <p className="text-content fw-bold">Tax</p>
                  <p className="text-content">
                    {currencyCode}
                    {formatNumber(order.total_tax)}
                  </p>
                </div>
                <div className="d-flex justify-content-between">
                  <p className="text-content fw-bold">Tax Provider</p>
                  <p className="text-content">Basic Tax</p>
                </div>
              </div>
            </div>
            <div className="col-md-5">
              <div className="second-section">
                <div className="d-flex justify-content-between">
                  <p className="text-content fw-bold">Payment provider</p>
                  <p className="text-content">{order.payment_method}</p>
                </div>
                {containsString(order.payment_method, MESSAGES.CREDIT_CARD) && (
                  <div className="d-flex justify-content-between">
                    <p className="text-content fw-bold">Paid by</p>
                    <p className="text-content">{MESSAGES.CREDIT_CARD}</p>
                  </div>
                )}

                <div className="d-flex justify-content-between">
                  <p className="text-content fw-bold">Order source</p>
                  <p className="text-content">
                    {formatWithSpaces(order.order_source)}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  order: state.RefundOrder.orderData,
  currencyCode: state.RefundOrder.currencyCode,
});
export default connect(mapStateToProps)(OrderSummaryCard);
